import React from 'react';
import { useParams } from 'react-router-dom';
import { Tabs } from 'antd';
import PropertyAnalysis from '../components/tabs/PropertyAnalysis';
import { useDocumentReady } from "../hooks/useDocumentReady";
import Spinner from "../components/common/Spinner";

const DocumentAnalysisPage: React.FC = () => {
    const { documentId } = useParams<{ documentId?: string }>();

    const { document, isLoading, error } = useDocumentReady(documentId);

    if (!documentId) {
        return <div className="text-center mt-10">Документ не выбран.</div>;
    }

    if (isLoading) {
        return <Spinner />;
    }

    if (error) {
        return (
            <div className="text-center mt-10 text-red-600">
                Ошибка: {error}
            </div>
        );
    }

    if (!document) {
        return (
            <div className="text-center mt-10">
                Документ не найден или был удалён.
            </div>
        );
    }

    const items = [
        {
            key: '1',
            label: 'Анализ Свойств',
            children: <PropertyAnalysis documentData={document} />,
        },
    ];

    return (
        <div className="p-4">
            <Tabs defaultActiveKey="1" items={items} />
        </div>
    );
};

export default DocumentAnalysisPage;
